import WelcomeContainer from '../../wrappers/WelcomeContainer'
import ForgoPassword from '../../../ui-kit/static/images/stories/forgot-password.svg'
import FormInput from '../../../ui-kit/components/templates/FormInput'
import {Link} from 'react-router-dom'

const ForgottenPasswordForm = () => {
  return (
    <WelcomeContainer
      title="¿Olvidaste tu contraseña?"
      subtitle="Enviaremos a tu correo las indicaciones para poder recuperar tu cuenta"
      graphic={ForgoPassword}
    >
      <FormInput type="email" label="Correo electrónico" placeholder="juan@gmail.com" />
      <button className="button">Restablece tu contraseña</button>
      <p>
        ¿Ya tienes tu cuenta? <Link to="">Inicia sesión</Link>
      </p>
    </WelcomeContainer>
  )
}

export default ForgottenPasswordForm
